export const Capability_catalogue = 'CC';
export const Capability_adoption_reporting = 'CAR';
export const Sample_Central = 'SC';
export const Rac = 'RAC';
export const Atlas = 'ATL';
export const AtlasFR = 'ATL-FR';
export const AtlasDE = 'ATL-DE';
export const AUE = 'AUE';
export const PowerX = 'POWX';
export const PatientIq = 'PIQ';
export const AZSA = 'AZSA';
export const GTP = "GTP";
export const CODE = 'AZ 2D Code App';
export const HUB = 'Search Hub';
export const EP = 'MAP';
export const OCL = 'OCL';
export const IVS = 'IVS';
export const PBI = 'PBI';
export const PCD = 'PCD';
export const PIM = 'PIM';
export const PUEBLO = 'PUEBLO';
export const JPC = 'JPC';
export const JMH = 'JMH';
export const JMD = 'JMD';
export const JMA = 'JMA';
export const REGISTA = 'REGISTA';
export const AZCMS = 'AZCMS';
export const RR = 'MYACCESS';
export const MOR = 'MOR';
export const CAP = 'CAP';
export const WAINUA = 'WAINUA';
export const INTERRO = 'INTERRO';
export const PowerbiUrl="https://app.powerbi.com/Redirect?action=OpenApp&appId=116ec666-0978-4716-a494-8526ac0da76f&ctid=af8e89a3-d9ac-422f-ad06-cc4eb4214314"
export const DevPowerbiUrl="https://app.powerbi.com/groups/me/reports/5ac62d31-237d-487e-9a1f-46c936c2a492/7938e3e4e9f17e9eff7e?ctid=af8e89a3-d9ac-422f-ad06-cc4eb4214314&experience=power-bi"
export const CodeUrl = "https://barcode.astrazeneca.jp/home";
export const HubUrl = "https://d2a83o4gwi0ggx.cloudfront.net/searchHub";
export const EPUrl = "https://d2a83o4gwi0ggx.cloudfront.net/map";
export const NoAccessAPP = [Capability_catalogue, Capability_adoption_reporting, CODE, HUB, EP];
export const OpticAccessLink = "https://aznextgen.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D6b9c302e83728e907d84c670deaad3a9%26sysparm_link_parent%3Dc7dda6661b8042103dcbeb91b24bcb22%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_default%26sysparm_view%3Dtext_search";